export const PERMISSIONS = {
  ACTIVITY_LOGS_DESTROY: 'activity-logs.destroy',
  ACTIVITY_LOGS_SHOW: 'activity-logs.show',

  ADMINS_CREATE: 'admins.create',
  ADMINS_DESTROY: 'admins.destroy',
  ADMINS_EXPORT: 'admins.export',
  ADMINS_IMPORT: 'admins.import',
  ADMINS_SHOW: 'admins.show',
  ADMINS_UPDATE: 'admins.update',

  ATTRIBUTE_GROUPS_CREATE: 'attribute-groups.create',
  ATTRIBUTE_GROUPS_DESTROY: 'attribute-groups.destroy',
  ATTRIBUTE_GROUPS_REORDER: 'attribute-groups.reorder',
  ATTRIBUTE_GROUPS_SHOW: 'attribute-groups.show',
  ATTRIBUTE_GROUPS_UPDATE: 'attribute-groups.update',

  ATTRIBUTE_VALUES_CREATE: 'attribute-values.create',
  ATTRIBUTE_VALUES_DESTROY: 'attribute-values.destroy',
  ATTRIBUTE_VALUES_REORDER: 'attribute-values.reorder',
  ATTRIBUTE_VALUES_SHOW: 'attribute-values.show',
  ATTRIBUTE_VALUES_UPDATE: 'attribute-values.update',

  ATTRIBUTES_CREATE: 'attributes.create',
  ATTRIBUTES_DESTROY: 'attributes.destroy',
  ATTRIBUTES_REORDER: 'attributes.reorder',
  ATTRIBUTES_SHOW: 'attributes.show',
  ATTRIBUTES_UPDATE: 'attributes.update',

  CAR_RENTALS_CREATE: 'car-rentals.create',
  CAR_RENTALS_DESTROY: 'car-rentals.destroy',
  CAR_RENTALS_RECORD: 'car-rentals.record',
  CAR_RENTALS_SHOW: 'car-rentals.show',
  CAR_RENTALS_UPDATE: 'car-rentals.update',
  CAR_WASHES_CREATE: 'car_washes.create',

  CAR_WASHES_DESTROY: 'car_washes.destroy',
  CAR_WASHES_EXPORT: 'car_washes.export',
  CAR_WASHES_IMPORT: 'car_washes.import',
  CAR_WASHES_SHOW: 'car_washes.show',
  CAR_WASHES_UPDATE: 'car_washes.update',

  CITIES_CREATE: 'cities.create',
  CITIES_DESTROY: 'cities.destroy',
  CITIES_EXPORT: 'cities.export',
  CITIES_SHOW: 'cities.show',
  CITIES_UPDATE: 'cities.update',

  COLORS_CREATE: 'colors.create',
  COLORS_DESTROY: 'colors.destroy',
  COLORS_SHOW: 'colors.show',
  COLORS_UPDATE: 'colors.update',

  CONFIGS_SHOW: 'configs.show',
  CONFIGS_UPDATE: 'configs.update',

  CONTACT_MESSAGES_DESTROY: 'contact-messages.destroy',
  CONTACT_MESSAGES_SHOW: 'contact-messages.show',
  CONTACT_MESSAGES_UPDATE: 'contact-messages.update',

  COUNTRIES_CREATE: 'countries.create',
  COUNTRIES_DESTROY: 'countries.destroy',
  COUNTRIES_SHOW: 'countries.show',
  COUNTRIES_UPDATE: 'countries.update',

  DRIVERS_CREATE: 'drivers.create',
  DRIVERS_DESTROY: 'drivers.destroy',
  DRIVERS_EXPORT: 'drivers.export',
  DRIVERS_SHOW: 'drivers.show',
  DRIVERS_UPDATE: 'drivers.update',

  EMERGENCIES_ASSIGN_SERVICE_CENTER: 'emergencies.assign_service_center',
  EMERGENCIES_ASSIGN_SUPPORTER: 'emergencies.assign_supporter',
  EMERGENCIES_CREATE: 'emergencies.create',
  EMERGENCIES_DESTROY: 'emergencies.destroy',
  EMERGENCIES_EXPORT: 'emergencies.export',
  EMERGENCIES_RESOLVE: 'emergencies.resolve',
  EMERGENCIES_SHOW: 'emergencies.show',
  EMERGENCIES_UPDATE: 'emergencies.update',

  FUEL_BRANDS_CREATE: 'fuel_brands.create',
  FUEL_BRANDS_DESTROY: 'fuel_brands.destroy',
  FUEL_BRANDS_EXPORT: 'fuel_brands.export',
  FUEL_BRANDS_IMPORT: 'fuel_brands.import',
  FUEL_BRANDS_SHOW: 'fuel_brands.show',
  FUEL_BRANDS_UPDATE: 'fuel_brands.update',

  GAS_STATIONS_CREATE: 'gas_stations.create',
  GAS_STATIONS_DESTROY: 'gas_stations.destroy',
  GAS_STATIONS_EXPORT: 'gas_stations.export',
  GAS_STATIONS_IMPORT: 'gas_stations.import',
  GAS_STATIONS_SHOW: 'gas_stations.show',
  GAS_STATIONS_UPDATE: 'gas_stations.update',

  LEAVE_REQUESTS_CREATE: 'leave_requests.create',
  LEAVE_REQUESTS_DESTROY: 'leave_requests.destroy',
  LEAVE_REQUESTS_EXPORT: 'leave_requests.export',
  LEAVE_REQUESTS_SHOW: 'leave_requests.show',
  LEAVE_REQUESTS_UPDATE: 'leave_requests.update',

  MAINTENANCE_ROUTES_ACCEPT: 'maintenance_routes.accept',
  MAINTENANCE_ROUTES_CREATE: 'maintenance_routes.create',
  MAINTENANCE_ROUTES_DESTROY: 'maintenance_routes.destroy',
  MAINTENANCE_ROUTES_EXPORT: 'maintenance_routes.export',
  MAINTENANCE_ROUTES_REJECT: 'maintenance_routes.reject',
  MAINTENANCE_ROUTES_SHOW: 'maintenance_routes.show',
  MAINTENANCE_ROUTES_UPDATE: 'maintenance_routes.update',

  NOTIFICATIONS_RESEND: 'notifications.resend',
  NOTIFICATIONS_SEND: 'notifications.send',
  NOTIFICATIONS_SHOW: 'notifications.show',
  OFFICES_CREATE: 'offices.create',
  OFFICES_DESTROY: 'offices.destroy',
  OFFICES_EXPORT: 'offices.export',
  OFFICES_IMPORT: 'offices.import',
  OFFICES_SHOW: 'offices.show',
  OFFICES_UPDATE: 'offices.update',
  PAYSLIPS_CREATE: 'payslips.create',
  PAYSLIPS_DESTROY: 'payslips.destroy',

  PAYSLIPS_EXPORT: 'payslips.export',
  PAYSLIPS_IMPORT: 'payslips.import',
  PAYSLIPS_SHOW: 'payslips.show',
  PAYSLIPS_UPDATE: 'payslips.update',

  RENTAL_CONTRACTS_CREATE: 'rental-contracts.create',
  RENTAL_CONTRACTS_DESTROY: 'rental-contracts.destroy',
  RENTAL_CONTRACTS_EXPORT: 'rental-contracts.export',
  RENTAL_CONTRACTS_SHOW: 'rental-contracts.show',
  RENTAL_CONTRACTS_UPDATE: 'rental-contracts.update',

  // One permission per report — covers both viewing and exporting that report
  // (there is no separate export permission; export buttons gate on the same .show key)
  REPORTS_ACTIVE_TRIPS_REPORTS_SHOW: 'reports.active-trips.show',

  REPORTS_DRIVER_FEEDBACK_REPORTS_SHOW: 'reports.driver-feedback.show',
  REPORTS_DRIVER_TRIPS_REPORTS_SHOW: 'reports.driver-trips.show',
  REPORTS_FEEDBACK_TRENDS_REPORTS_SHOW: 'reports.feedback-trends.show',
  REPORTS_NUMBER_OF_TRIPS_REPORTS_SHOW: 'reports.number-of-trips.show',
  REPORTS_ROUTE_DETAILS_REPORTS_SHOW: 'reports.route-details.show',
  REPORTS_SPEED_VIOLATIONS_PER_DRIVER_REPORTS_SHOW:
    'reports.speed-violations-per-driver.show',
  REPORTS_SPEED_VIOLATIONS_REPORTS_SHOW: 'reports.speed-violations.show',
  REPORTS_TRIP_BOOKING_REPORTS_SHOW: 'reports.trip-booking.show',
  REPORTS_TRIP_DETAILS_REPORTS_SHOW: 'reports.trip-details.show',
  REPORTS_TRIP_KM_REPORTS_SHOW: 'reports.trip-km.show',
  REPORTS_TRIP_REPORTS_SHOW: 'reports.trip.show',
  REPORTS_TRIP_STOPS_REPORTS_SHOW: 'reports.trip-stops.show',
  REPORTS_VEHICLE_FEEDBACK_REPORTS_SHOW: 'reports.vehicle-feedback.show',
  REPORTS_VEHICLE_REPORTS_SHOW: 'reports.vehicle.show',

  RESIGNATION_REQUESTS_CREATE: 'resignation_requests.create',
  RESIGNATION_REQUESTS_DESTROY: 'resignation_requests.destroy',

  RESIGNATION_REQUESTS_EXPORT: 'resignation_requests.export',

  RESIGNATION_REQUESTS_SHOW: 'resignation_requests.show',
  RESIGNATION_REQUESTS_UPDATE: 'resignation_requests.update',
  ROLES_CREATE: 'roles.create',

  ROLES_DESTROY: 'roles.destroy',

  ROLES_SHOW: 'roles.show',
  ROLES_UPDATE: 'roles.update',
  ROUTE_SHIFT_PASSENGERS_CREATE: 'route-shift-passengers.create',
  ROUTE_SHIFT_PASSENGERS_DESTROY: 'route-shift-passengers.destroy',

  ROUTE_SHIFT_PASSENGERS_EXPORT: 'route-shift-passengers.export',

  ROUTE_SHIFT_PASSENGERS_SHOW: 'route-shift-passengers.show',
  ROUTE_SHIFT_PASSENGERS_UPDATE: 'route-shift-passengers.update',
  ROUTE_SHIFT_REROUTE_REQUESTS_EXPORT: 'route-shift-reroute-requests.export',
  ROUTE_SHIFT_REROUTE_REQUESTS_MANAGE: 'route-shift-reroute-requests.manage',

  ROUTE_SHIFT_REROUTE_REQUESTS_SHOW: 'route-shift-reroute-requests.show',

  ROUTE_SHIFTS_CREATE: 'route-shifts.create',
  ROUTE_SHIFTS_DESTROY: 'route-shifts.destroy',
  ROUTE_SHIFTS_EXPORT: 'route-shifts.export',
  ROUTE_SHIFTS_SHOW: 'route-shifts.show',

  ROUTE_SHIFTS_UPDATE: 'route-shifts.update',

  SERVICE_CENTERS_CREATE: 'service_centers.create',
  SERVICE_CENTERS_DESTROY: 'service_centers.destroy',
  SERVICE_CENTERS_EXPORT: 'service_centers.export',
  SERVICE_CENTERS_IMPORT: 'service_centers.import',
  SERVICE_CENTERS_SHOW: 'service_centers.show',
  SERVICE_CENTERS_UPDATE: 'service_centers.update',
  SERVICE_ROUTES_CANCEL: 'service_routes.cancel',
  SERVICE_ROUTES_COMPLETE: 'service_routes.complete',
  SERVICE_ROUTES_EXPORT: 'service_routes.export',
  SERVICE_ROUTES_SHOW: 'service_routes.show',
  SPECIAL_OPTIONS_CREATE: 'special-options.create',
  SPECIAL_OPTIONS_DESTROY: 'special-options.destroy',
  SPECIAL_OPTIONS_REORDER: 'special-options.reorder',
  SPECIAL_OPTIONS_SHOW: 'special-options.show',
  SPECIAL_OPTIONS_UPDATE: 'special-options.update',

  STATES_CREATE: 'states.create',

  STATES_DESTROY: 'states.destroy',
  STATES_EXPORT: 'states.export',
  STATES_SHOW: 'states.show',
  STATES_UPDATE: 'states.update',
  SUPER_ADMIN: 'super-admin',
  SUPPORT_TICKETS_DESTROY: 'support-tickets.destroy',
  SUPPORT_TICKETS_EXPORT: 'support-tickets.export',
  SUPPORT_TICKETS_REPLY: 'support-tickets.reply',

  SUPPORT_TICKETS_SHOW: 'support-tickets.show',
  SUPPORT_TICKETS_UPDATE: 'support-tickets.update',
  SYSTEM_MANAGE: 'system.manage',
  SYSTEM_SHOW: 'system.show',

  TENANT_ADMINS_CREATE: 'tenant-admins.create',
  TENANT_ADMINS_DESTROY: 'tenant-admins.destroy',
  TENANT_ADMINS_EXPORT: 'tenant-admins.export',
  TENANT_ADMINS_IMPORT: 'tenant-admins.import',
  TENANT_ADMINS_SHOW: 'tenant-admins.show',
  TENANT_ADMINS_UPDATE: 'tenant-admins.update',
  TENANT_BRANCHES_CREATE: 'tenant-branches.create',
  TENANT_BRANCHES_DESTROY: 'tenant-branches.destroy',
  TENANT_BRANCHES_EXPORT: 'tenant-branches.export',
  TENANT_BRANCHES_SHOW: 'tenant-branches.show',
  TENANT_BRANCHES_UPDATE: 'tenant-branches.update',

  TENANT_CONTRACTS_CREATE: 'tenant-contracts.create',
  TENANT_CONTRACTS_DESTROY: 'tenant-contracts.destroy',
  TENANT_CONTRACTS_SHOW: 'tenant-contracts.show',
  TENANT_CONTRACTS_UPDATE: 'tenant-contracts.update',
  TENANT_ROLES_CREATE: 'tenant-roles.create',
  TENANT_ROLES_DESTROY: 'tenant-roles.destroy',
  TENANT_ROLES_SHOW: 'tenant-roles.show',
  TENANT_ROLES_UPDATE: 'tenant-roles.update',
  TENANT_ROUTES_CREATE: 'tenant-routes.create',
  TENANT_ROUTES_DESTROY: 'tenant-routes.destroy',
  TENANT_ROUTES_EXPORT: 'tenant-routes.export',
  TENANT_ROUTES_IMPORT: 'tenant-routes.import',
  TENANT_ROUTES_SHOW: 'tenant-routes.show',
  TENANT_ROUTES_UPDATE: 'tenant-routes.update',
  TENANTS_CREATE: 'tenants.create',

  TENANTS_DESTROY: 'tenants.destroy',
  TENANTS_EXPORT: 'tenants.export',
  TENANTS_IMPORT: 'tenants.import',
  TENANTS_OWNERS_SHOW: 'tenants.owners.show',
  TENANTS_SHOW: 'tenants.show',

  TENANTS_UPDATE: 'tenants.update',
  TENANTS_WORKING_HOURS_SHOW: 'tenants.working-hours.show',
  TICKETS_CREATE: 'tickets.create',
  TICKETS_DESTROY: 'tickets.destroy',

  TICKETS_EXPORT: 'tickets.export',
  TICKETS_SHOW: 'tickets.show',
  TICKETS_UPDATE: 'tickets.update',

  TRIP_FEEDBACKS_DESTROY: 'trip-feedbacks.destroy',
  TRIP_FEEDBACKS_EXPORT: 'trip-feedbacks.export',
  TRIP_FEEDBACKS_REVIEW: 'trip-feedbacks.review',
  TRIP_FEEDBACKS_SHOW: 'trip-feedbacks.show',

  TRIP_PASSENGERS_CREATE: 'trip-passengers.create',
  TRIP_PASSENGERS_DESTROY: 'trip-passengers.destroy',
  TRIP_PASSENGERS_EXPORT: 'trip-passengers.export',
  TRIP_PASSENGERS_SHOW: 'trip-passengers.show',
  TRIP_PASSENGERS_UPDATE: 'trip-passengers.update',

  TRIP_REQUESTS_CREATE: 'trip-requests.create',
  TRIP_REQUESTS_DESTROY: 'trip-requests.destroy',
  TRIP_REQUESTS_EXPORT: 'trip-requests.export',
  TRIP_REQUESTS_SHOW: 'trip-requests.show',
  TRIP_REQUESTS_UPDATE: 'trip-requests.update',

  TRIPS_BACKLOG_CREATE: 'trips.backlog-create',
  TRIPS_CREATE: 'trips.create',
  TRIPS_DESTROY: 'trips.destroy',
  TRIPS_EXPORT: 'trips.export',
  TRIPS_SHOW: 'trips.show',
  TRIPS_UPDATE: 'trips.update',
  USERS_CREATE: 'users.create',
  USERS_DESTROY: 'users.destroy',

  USERS_EXPORT: 'users.export',
  USERS_IMPORT: 'users.import',
  USERS_SHOW: 'users.show',
  USERS_UPDATE: 'users.update',

  VEHICLE_BRANDS_CREATE: 'vehicle-brands.create',
  VEHICLE_BRANDS_DESTROY: 'vehicle-brands.destroy',
  VEHICLE_BRANDS_IMPORT: 'vehicle-brands.import',
  VEHICLE_BRANDS_REORDER: 'vehicle-brands.reorder',
  VEHICLE_BRANDS_SHOW: 'vehicle-brands.show',
  VEHICLE_BRANDS_UPDATE: 'vehicle-brands.update',
  VEHICLE_MODELS_CREATE: 'vehicle-models.create',
  VEHICLE_MODELS_DESTROY: 'vehicle-models.destroy',
  VEHICLE_MODELS_IMPORT: 'vehicle-models.create',
  VEHICLE_MODELS_REORDER: 'vehicle-models.reorder',
  VEHICLE_MODELS_SHOW: 'vehicle-models.show',
  VEHICLE_MODELS_UPDATE: 'vehicle-models.update',
  VEHICLE_TYPES_CREATE: 'vehicle-types.create',
  VEHICLE_TYPES_DESTROY: 'vehicle-types.destroy',
  VEHICLE_TYPES_IMPORT: 'vehicle-types.create',
  VEHICLE_TYPES_REORDER: 'vehicle-types.reorder',
  VEHICLE_TYPES_SHOW: 'vehicle-types.show',
  VEHICLE_TYPES_UPDATE: 'vehicle-types.update',
  VEHICLES_APPROVE: 'vehicles.approve',
  VEHICLES_CREATE: 'vehicles.create',
  VEHICLES_DESTROY: 'vehicles.destroy',
  VEHICLES_EXPORT: 'vehicles.export',
  VEHICLES_IMPORT: 'vehicles.import',
  VEHICLES_REORDER: 'vehicles.reorder',
  VEHICLES_SHOW: 'vehicles.show',
  VEHICLES_UPDATE: 'vehicles.update',
  VEHICLES_UPDATE_ATTRIBUTES: 'vehicles.update-attributes',

  /*
   * Keys below are APPENDED (not sorted) on purpose: the session cookie stores
   * permissions as indexes into Object.values(PERMISSIONS) (see
   * permissions-utils.ts), so inserting keys mid-object would shift every
   * index after it. Always add new keys at the end.
   */
  /* eslint-disable perfectionist/sort-objects */
  ROUTE_SHIFTS_IMPORT: 'route-shifts.import',
  ROUTE_SHIFT_PASSENGERS_IMPORT: 'route-shift-passengers.import',
  TRIPS_IMPORT: 'trips.import',
  TRIP_REQUESTS_IMPORT: 'trip-requests.import',
  DRIVERS_IMPORT: 'drivers.import',
  IMPORTS_MASTER: 'imports.master',
  VEHICLE_BRANDS_EXPORT: 'vehicle-brands.export',
  VEHICLE_MODELS_EXPORT: 'vehicle-models.export',
  VEHICLE_TYPES_EXPORT: 'vehicle-types.export',
  COUNTRIES_EXPORT: 'countries.export',
  SPECIAL_OPTIONS_EXPORT: 'special-options.export'
  /* eslint-enable perfectionist/sort-objects */
} as const

export type PERMISSION = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]

declare global {
  type PERMISSION = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]
}
